module.exports = __webpack_public_path__ + "static/media/menu_icon_03.56dd46d4.png";